import { render, staticRenderFns } from "./NavItems.vue?vue&type=template&id=43d2d6f4&scoped=true"
import script from "./NavItems.vue?vue&type=script&lang=js"
export * from "./NavItems.vue?vue&type=script&lang=js"
import style0 from "./NavItems.vue?vue&type=style&index=0&id=43d2d6f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43d2d6f4",
  null
  
)

export default component.exports